module.exports = __webpack_public_path__ + "static/common-logistic-distribution-6ffbae2fe8189043c12d6252bcbc2217.png";